div<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong>Historique livraisons</strong>
      </b-card-header>
      <div v-for="(livraison, key) in items" :key="key">
        <div class="body-card m-2">
          <b-card no-body style="margin-bottom:10px">
            <div class="card-smallHeader card-header-action" v-b-toggle="'collapse-livraisons-'+key">
              <span><b style="color: #349ee2">v {{ livraison.numero_version }}</b> du {{ formatDate(livraison.date_livraison) }}</span>
              <div class="card-header-actions">
                <span class="when-opened">
                  <i class="icon-arrow-down"></i>
                </span>
                <span class="when-closed">
                  <i class="icon-arrow-up"></i>
                </span>
              </div>
            </div>
            <b-collapse :id="'collapse-livraisons-'+ key" :visible="livraison.is_active===true" class="m-3" style="margin-top:15px;">
              <b-card-body class="small-padding">
                <b-row class="mb-1">
                  <b-col sm="11">
                    <div class="block-livraison" v-html="livraison.contenu"></div>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>
      <b-row class="mr-1 ml-1 mb-1 mt-3" v-if="canAccess(rules.CAN_ACCESS_HISTO_LIVRAISONS)" v-show="moreExists">
        <b-button class="mr-1 float-right mb-1" type="enter" @click.prevent="loadMore(nextPage)" size="md" variant="link">
          <i class="fa fa-arrow-down"></i>
          Voir plus
        </b-button>
      </b-row>
    </b-card>
  </div>
</template>

<script>
  import { getAccessToken, getBaseUrl, getIdToken, getProvider } from "../../../utils/auth";
  import { rules, hasRule } from '@/utils/rulesHelper';

  export default {
    name: "HistoVersions",
    data() {
      return {
        rules: rules,
        columns: ['date_livraison', 'titre', 'commentaire', 'action'],
        items: [],
        moreExists: false,
        nextPage: 0,
        previousPage: 0,
        options: {
          headings: {
            'date_livraison': 'Date',
            'titre': 'Titre',
            'commentaire': 'Commentaire'
          },
          filterable: ['titre'],
          perPage: 10,
          perPageValues: [10, 25, 50],
          texts: {
            filterPlaceholder: "Titre"
          },
        }
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.all();
    },
    methods: {
      canAccess(rule) {
        return hasRule(rule)
      },
      all() {
        let self = this
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .get("/administration/last-versions/list")
          .then(response => {
            this.items = response.data.livraisons.data
            if (response.data.livraisons.current_page < response.data.livraisons.last_page) {
              this.moreExists = true
              this.nextPage = response.data.livraisons.current_page + 1
            } else {
              this.moreExists = false
            }
            this.$store.commit('IS_LOADING', false)
          })
          .catch(() => {
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Un probléme est survenue, merci de contacter l\'administrateur',
              showConfirmButton: false,
              timer: 5000
            })
          });
      },
      loadMore(nextPage) {
        let self = this
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .get("/administration/last-versions/list?page="+nextPage)
          .then(response => {
            if (response.data.livraisons.current_page < response.data.livraisons.last_page) {
              this.moreExists = true
              this.nextPage = response.data.livraisons.current_page + 1
            } else {
              this.moreExists = false
            }
            response.data.livraisons.data.forEach(data => {
              this.items.push(data)
            })
            this.$store.commit('IS_LOADING', false)
          })
          .catch((error) => {
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Un probléme est survenue, merci de contacter l\'administrateur',
              showConfirmButton: false,
              timer: 5000
            })
          });
      },
      formatDate(textDate) {
        let date = textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
        return date;
      },
    }
  }
</script>
